import React from 'react';

import { Styled } from './ErrorPage.styles';

import umpLogo from 'images/umpLogo.svg';
import { useHistory } from 'react-router';
import { Props } from './ErrorPage.types';

export const ErrorPage: React.FC<Props> = ({
  title,
  children,
  actionButtonText,
  actionCallback,
}) => (
  <Styled.PageWrapper>
    <Styled.ImageWrapper>
      <img alt="logo" width={150} height={150} src={umpLogo} />
    </Styled.ImageWrapper>
    <h1>{title}</h1>
    {children}
    <button onClick={actionCallback}>{actionButtonText}</button>
  </Styled.PageWrapper>
);
